import { render, staticRenderFns } from "./UserVerificationCardV2.vue?vue&type=template&id=5b72c834&scoped=true"
import script from "./UserVerificationCardV2.vue?vue&type=script&lang=js"
export * from "./UserVerificationCardV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b72c834",
  null
  
)

export default component.exports